import React from "react";
import styles from "./Brands.module.css";

const brands = [
  {
    id: 1,
    name: "ADIDAS",
    image:
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: 2,
    name: "LACOSTE",
    image:
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: 3,
    name: "LEVI'S",
    image:
"/brands2.jpg"  }, 
  {
    id: 4,
    name: "CHAMPION",
    image:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: 5,
    name: "PUMA",
    image:
      "https://media.gettyimages.com/id/2243572841/photo/30-october-2025-bavaria-herzogenaurach-a-puma-shoe-the-fast-r-3-nitro-stands-in-a-puma.jpg?s=612x612&w=0&k=20&c=yrV8ZtsSG_K5qRCLLJHhGhXK3tfQgnz5DilIEB1X0Oo=",
  },
  {
    id: 6,
    name: "NIKE",
    image:
      "https://media.gettyimages.com/id/2275590768/photo/paris-france-emy-venturini-wears-white-sneakers-shoes-by-nike-during-a-street-style-fashion.jpg?s=612x612&w=0&k=20&c=I9_y_bNdWNC5McxFHzruyPIRkr0KfLd0gsT6x_GKnrE=",
  },
];

const BrandSlider = () => {
  return (
    <div className={styles.brandSection}>
      {/* TITLE */}
      <div className={styles.titleWrapper}>
        <div className={styles.line}></div>

        <h1 className={styles.title}>Brand You Love</h1>

        <div className={styles.line}></div>
      </div>

   

      {/* SLIDER */}
      <div className={styles.slider}>
        <div className={styles.slideTrack}>
          {[...brands, ...brands].map((brand, index) => (
            <div className={styles.brandCard} key={index}>
              <img src={brand.image} alt={brand.name} />

              <div className={styles.brandOverlay}>
                <h2>{brand.name}</h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandSlider;